import styled from 'styled-components';

// Barras de comparacao por maquina — tokens CCO. accent ucha=laranja,
// eba=azul (convencao do app).
const accentColor = (props) =>
  props.$accent === 'eba' ? 'var(--cco-blue)' : 'var(--cco-orange)';

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const RowHead = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
`;

export const Name = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: var(--cco-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Value = styled.span`
  font-size: 14px;
  font-weight: 800;
  color: var(--cco-ink);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
`;

export const Flow = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: var(--cco-ink-faint);
`;

export const BarTrack = styled.div`
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: var(--cco-soft-surface);
  border: 1px solid var(--cco-line);
  overflow: hidden;
`;

export const BarFill = styled.div`
  height: 100%;
  border-radius: 999px;
  background: ${accentColor};
  transition: width 400ms ease;
  min-width: 2px;
`;
